'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["panelKey", "width"];
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import omit from '../utils/underscore/omit';
import UIModalDialog from './UIModalDialog';
import { hidden } from '../utils/propTypes/decorators';
import * as PanelContext from '../context/PanelContext';
import ModalPanelTransition from './internal/ModalPanelTransition';
import AbstractModal from './internal/AbstractModal';
import { callIfPossible } from '../core/Functions';
import { isSafari } from '../utils/BrowserTest';
import { createPlacementWarning, DropdownContext } from '../context/DropdownContext';
import { jsx as _jsx } from "react/jsx-runtime";
const inPanelContext = {
  inPanel: true
};
class UIModalPanel extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleOpenComplete = () => {
      const {
        onOpenComplete
      } = this.props;
      callIfPossible(onOpenComplete);
      if (isSafari()) {
        this._autoFocusedEl.focus();
      }
    };
  }
  componentDidMount() {
    // Safari glitches the transition if an element in the modal panel is focused (#6033)
    if (isSafari()) {
      this._autoFocusedEl = document.activeElement;
      this._autoFocusedEl.blur();
    }
  }
  render() {
    const _this = this,
      {
        context: {
          shouldLogModalWarning
        },
        props: {
          width
        }
      } = _this,
      rest = _objectWithoutPropertiesLoose(_this.props, _excluded);
    const _createPlacementWarning = createPlacementWarning(UIModalPanel.displayName);
    if (shouldLogModalWarning) {
      _createPlacementWarning();
    }
    return /*#__PURE__*/_jsx(PanelContext.Provider, {
      value: inPanelContext,
      children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
        _use: "sidebar",
        _dialogWidth: width,
        componentName: "UIModalPanel",
        Transition: ModalPanelTransition,
        onOpenComplete: this.handleOpenComplete
      }))
    });
  }
}
UIModalPanel.propTypes = Object.assign({}, omit(UIModalDialog.propTypes, ['centered', 'size', 'use']), {
  onCloseComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onOpenStart: PropTypes.func,
  panelKey: hidden(PropTypes.string),
  _contextual: PropTypes.bool,
  rootNode: AbstractModal.propTypes.rootNode
});
UIModalPanel.defaultProps = {
  width: 700,
  _contextual: false
};
UIModalPanel.displayName = 'UIModalPanel';
UIModalPanel.contextType = DropdownContext;
export default UIModalPanel;